// extracted by mini-css-extract-plugin
export var copyable = "_p-1";
export var explainable = "_p-0";
export var negative = "_p-2";
export var positive = "_p-3";